import { useMemo } from 'react'

import { Dropdown, Tooltip } from 'antd'

import { WpsSubscriptIcon } from '@eastcoal/icon/WpsSubscriptIcon'
import { WpsSuperscriptIcon } from '@eastcoal/icon/WpsSuperscriptIcon'

import { useSelectionTextFormat } from '../../hooks/useSelectionTextFormat'
import { SHORTCUTS } from '../../plugins/ShortcutsPlugin/shortcuts'
import { DropdownButton } from '../../ui/DropdownButton'

const items = [
  {
    key: 'superscript',
    label: (
      <Tooltip placement='right' title={SHORTCUTS.SUPERSCRIPT}>
        上标
      </Tooltip>
    ),
    icon: <WpsSuperscriptIcon />
  },
  {
    key: 'subscript',
    label: (
      <Tooltip placement='right' title={SHORTCUTS.SUBSCRIPT}>
        下标
      </Tooltip>
    ),
    icon: <WpsSubscriptIcon />
  }
]

export const SuperSubDropdown = () => {
  const [superscript, toggleSuperscript] = useSelectionTextFormat('superscript')
  const [subscript, toggleSubscript] = useSelectionTextFormat('subscript')
  const selectedKeys = useMemo(() => {
    if (superscript) return ['superscript']
    if (subscript) return ['subscript']
    return []
  }, [superscript, subscript])

  return (
    <Dropdown
      menu={{
        items,
        selectedKeys,
        onClick: ({ key }) => {
          if (key === 'superscript') {
            toggleSuperscript()
          } else if (key === 'subscript') {
            toggleSubscript()
          }
        }
      }}
    >
      <DropdownButton>
        <WpsSuperscriptIcon />
      </DropdownButton>
    </Dropdown>
  )
}
